<template>
  
  <div class="w-full flex flex-col">
    <div class="flex flex-row justify-between items-center gap-2">
      <div class="flex flex-row items-center gap-2">
        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
          <g clip-path="url(#clip0_848_24383)">
            <path
              d="M11.5352 16.0001L5.42948 14.1684L1.88941 15.3287C1.5385 15.4449 1.20973 15.399 0.903082 15.1908C0.596437 14.9827 0.443115 14.6778 0.443115 14.276V2.50692C0.443115 2.25506 0.513925 2.02804 0.655545 1.82587C0.796994 1.62371 0.973468 1.48675 1.18496 1.41501L5.42948 0L11.5352 1.83172L15.0753 0.671378C15.4262 0.521279 15.755 0.553843 16.0616 0.769071C16.3683 0.984299 16.5216 1.28959 16.5216 1.68493V13.5324C16.5216 13.7907 16.4502 14.0235 16.3074 14.231C16.1644 14.4384 15.9755 14.5695 15.7408 14.6243L11.5352 16.0001ZM10.8738 14.4386V2.99029L6.09093 1.54196V12.9902L10.8738 14.4386ZM12.1967 14.3877L15.1987 13.3935V1.99607L12.1967 2.99029V14.3877ZM1.76603 14.004L4.76802 12.9902V1.59284L1.76603 2.60665V14.004Z"
              fill="#4F4F4F" />
          </g>
          <defs>
            <clipPath id="clip0_848_24383">
              <rect width="16" height="16" fill="white" transform="translate(0.482422)" />
            </clipPath>
          </defs>
        </svg>
        <h4 class="nxp-review-title">Endereço</h4>
      </div>

      <button class="nxp-review-title-action" type="button" @click="$router.push({ name: 'edit-address' })">
        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
          <path
            d="M4.54 15.4993H5.46625L13.6633 7.30227L12.7371 6.37602L4.54 14.5731V15.4993ZM3.45667 16.5827V14.1164L13.8237 3.73331C13.9358 3.61886 14.0565 3.5374 14.1856 3.48893C14.3148 3.44032 14.4501 3.41602 14.5917 3.41602C14.7333 3.41602 14.8685 3.43872 14.9973 3.48414C15.1262 3.52956 15.251 3.60997 15.3717 3.72539L16.306 4.65164C16.4215 4.77234 16.5032 4.89734 16.5512 5.02664C16.5993 5.15595 16.6233 5.28907 16.6233 5.42602C16.6233 5.57199 16.5981 5.71129 16.5475 5.84393C16.4968 5.97657 16.4163 6.09782 16.306 6.20768L5.92292 16.5827H3.45667ZM13.1921 6.84727L12.7371 6.37602L13.6633 7.30227L13.1921 6.84727Z"
            fill="#4F4F4F" />
        </svg>
        Editar
      </button>
    </div>
    <hr class="custom-hr my-2" />

    <div v-if="show()" class="flex flex-col px-6">
      <div v-if="_postalCode != ''" class="nxp-review-data flex pl-1 my-1">
        <p><b>CEP: </b>{{ _postalCode }}</p>
      </div>

      <div v-if="_country != ''" class="nxp-review-data flex pl-1 my-1">
        <p><b>Pais: </b>{{ _country }}</p>
      </div>

      <div v-if="_state != ''" class="nxp-review-data flex pl-1 my-1">
        <p><b>Estado: </b>{{ _state }}</p>
      </div>

      <div v-if="_city != ''" class="nxp-review-data flex pl-1 my-1">
        <p><b>Cidade: </b>{{ _city }}</p>
      </div>
    </div>
    <div v-else class="w-full flex flex-col items-center justify-center space-y-4 py-8">
      <p class="nxp-review-no-data-text">
        Seu endereço ainda não foi preenchido. 
        <br />
        Adicione para encontrar vagas próximas.
      </p>
      <button class="nxp-review-no-data-btn" type="button" @click="$router.push({ name: 'edit-address' })">
        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
          <path
            d="M8.22616 8.75597H2.58252V7.24325H8.22616V1.59961H9.73888V7.24325H15.3825V8.75597H9.73888V14.3996H8.22616V8.75597Z"
            fill="#4F4F4F" />
        </svg>
        Adicionar Endereço
      </button>
    </div>

  </div>
</template>

<script>
import { mapState } from "vuex";
import { get } from "lodash";

import EmptyDetailCard from "@/components/dashboard/profile-detail/EmptyDetailCard";

export default {
  computed: {
    ...mapState("address", ["address"]),
    ...mapState("company", ["company"]),

    _postalCode() {
      return this.address != undefined || this.address != null
        ? this.address.postalcode
        : "";
    },

    _country() {
      return this.address != undefined || this.address != null
        ? this.address.country
        : "";
    },

    _state() {
      return this.address != undefined || this.address != null
        ? this.address.state
        : "";
    },

    _city() {
      return this.address != undefined || this.address != null
        ? this.address.city
        : "";
    },

    _addressNeighborhood() {
      return this.address != undefined || this.address != null
        ? this.address.address_neighborhood
        : "";
    },

    _address() {
      return this.address != undefined || this.address != null
        ? this.address.address
        : "";
    },

    _addressNumber() {
      return this.address != undefined || this.address != null
        ? this.address.address_number
        : "";
    },

    _addressComplement() {
      return this.address != undefined || this.address != null
        ? this.address.address_complement
        : "";
    },

    color() {
      return get(this.$store, 'state.company.base_hexcolor', '#1551b1');
    },
  },

  methods: {
    show() {
      return (
        Object.keys(this.address).filter((key) => this.address[key] != "")
          .length > 1
      );
    },
  },

  components: {
    EmptyDetailCard,
  },
};
</script>

<style lang="scss">
hr {
  height: 1px;
  background-color: rgba(0, 0, 0, 0.1);
  border: none;
}
</style>
